import { useMemo } from "react";

export const useDefinitionsOptions = (data) => {
  return useMemo(() => {
    if (!data) return [];

    const map = new Map();

    data?.forEach((definition) => {
      map.set(definition.uuid, {
        uuid: definition.uuid,
        name: definition.name,
        is_default_on_map: definition.is_default_on_map,
      });
    });

    return Array.from(map.values());
  }, [data]);
};
